import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import CardTitle from 'components/ui/card/CardTitle';
import translate from 'components/hoc/translate';

const ResourceNotFound = (props) => {
    const {
        translate,
    } = props;

    return (
        <Card>
            <CardTitle title={ translate('page.resource_not_found.title') } />

            <CardText>
                { translate('page.resource_not_found.description') }
            </CardText>
        </Card>
    );
};

ResourceNotFound.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default translate(ResourceNotFound);



// WEBPACK FOOTER //
// ./src/pages/NotFound/ResourceNotFound.js